import React from 'react';

const GreenCheckList = ({ items = [], className }) => {
  return (
    <ul className={`GreenCheckList ${className}`}>
      {items.map((item, idx) => (
        <li className="GreenCheckList__item" key={idx}>
          <i className="far fa-check" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
};

export default GreenCheckList;
